import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useChatNotification } from "../../context/ChatNotificationContext";
import {
  Col,
  Row,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import Button from "../../Components/Buttons/Button";
import { orderHistory } from "../../services/orderHistory";
import { dateFormat } from "./dateFormat";
import Doubtq from "../../Assets/logo/logo.png";
import Email from "../../Assets/logo/email.png";
import YouTube from "../../Assets/logo/youtube.png";
import Instagram from "../../Assets/logo/instagram.png";
import Linkedin from "../../Assets/logo/linkedin.png";
import Facebook from "../../Assets/logo/facebook.png";
import jsPDF from "jspdf";
import { Helmet } from "react-helmet";
import { FiSearch } from "react-icons/fi";
import "./search.scss";

const DashboardOrderHistory = () => {
  const [pageData, setPageData] = useState([]);
  const [search, setSearch] = useState("");
  const [paymentSection, setPaymentSection] = useState("AssignmentHelp");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [invoice, setInvoice] = useState(null);
  const [status, setStatus] = useState("Unpaid");
  const navigate = useNavigate();
  const { getUnreadCount } = useChatNotification();
const [loading, setLoading] = useState(true);
  const fetchData = async () => {
    try {
       setLoading(true);
        setPageData([]);
      const data = await orderHistory(search, currentPage, 10, status);
      setPageData(data?.data || []);
      setTotalPages(data?.totalPages || 1);
    } catch (err) {
      return err;
    }
    finally {
    setLoading(false);
  }
  };

  useEffect(() => {
    fetchData();
  }, [paymentSection, currentPage, status, search]);

  const handlePaginationClick = (page) => {
    setCurrentPage(page);
  };

  const formatDate = (dateString) => {
    const options = { month: "short", day: "numeric", year: "numeric" };
    return new Date(dateString).toLocaleDateString("en-US", options);
  };

  const handleViewButtonClick = (order) => {
    localStorage.setItem("serviceType", order.paymentSection || "Course");
    setPaymentSection(order.paymentSection);
    if (order.studentPaymentStatus === "Unpaid") {
      // navigate(`/orderStatus/${order._id}`);
      navigate(`/dashboard/orderStatus/${order._id}`);
    } else {
      let route = "";

      if (order?.paymentSection === "AssignmentHelp") {
        route = `/dashboard/viewanswer/${order._id}`;
      } else if (order?.paymentSection === "LiveSessionHelp") {
        route = `/dashboard/viewanswer-live/${order._id}`;
      } else if (order?.paymentSection === "HomeworkHelp") {
        route = `/dashboard/viewanswer-homework/${order._id}`;
      } else {
        route = `/dashboard/${order._id}`;
      }
      navigate(route, {
        state: order,
      });
    }
  };
  const yourInvoiceHTMLContent = `
  <!DOCTYPE html>
  <html>
  <head>
    <style>
      body {
        font-family: Arial, sans-serif;
        margin: 0;
        padding: 0;
        background-color: #f8f8f8;
      }
  
      #invoice-content {
        width: 650px;
        margin: 0 auto;
        padding: 20px;
        background-color: #fff;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        margin-top: 6%;
      }
  
      .header, .footer {
        text-align: center;
        margin-bottom: 30px;
      }
  
      .header img {
        max-width: 150px;
      }
  
      .header h1 {
        margin: 0;
        font-size: 24px;
        color: #333;
      }
  
      .invoice-details, .invoice-summary {
        margin-bottom: 20px;
      }
  
      .invoice-details p, .invoice-summary p {
        margin: 5px 0;
        font-size: 14px;
      }
  
      .invoice-summary {
        border-top: 2px solid #333;
        padding-top: 10px;
      }
  
      table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 20px;
      }
  
      table, th, td {
        border: 1px solid #ccc;
      }
  
      th, td {
        padding: 10px;
        text-align: left;
        font-size: 14px;
      }
  
      th {
        background-color: #f2f2f2;
      }
  
      .footer p {
        font-size: 12px;
        color: #777;
      }
      .footer{
        margin-top: 4%;
      }
      .contact-icons img {
        max-width: 24px;
        margin: 0 5px;
        padding-top: 20px;
      }
        .terms-conditions {
          margin-top: 20px;
          font-size: 12px;
        }
        .copyright{
          margin-top: 20px;
        }
    </style>
  </head>
  <body>
    <div id="invoice-content">
      <div class="header">
        <img src=${Doubtq} alt="Logo" />
        <h1>VAIDIK EDUCATION</h1>
        <p>B-603, Sky View Heights, Behind Midas Square, Surat, Gujarat, 395010, India</p>
      </div>
      <div class="invoice-details">
        <p><strong>BILL TO:</strong> ${invoice?.studentId?.email}</p>
        <p><strong>INVOICE ID:</strong> ${invoice?.displayId}</p>
        <p><strong>DATE:</strong> ${formatDate(invoice?.updatedAt)}</p>
        <p><strong>PAYMENT ID:</strong> ${invoice?.paymentId}</p>
        <p><strong>TYPE:</strong> ${invoice?.paymentSection}</p>
        <p><strong>CATEGORY:</strong> ${invoice?.subCategoryId?.name}</p>
        <p><strong>SUBJECT:</strong> ${invoice?.subjectId?.subSubjectName}</p>
      </div>
      <table>
        <thead>
          <tr>
            <th>Description</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Estimated Price</td>
            <td> ${invoice?.estimatedPrice?.toFixed(2)}</td>
          </tr>
          <tr>
            <td>Promo Price</td>
            <td> ${invoice?.promoPrice?.toFixed(2)}</td>
          </tr>
          <tr>
            <td>Discount Price</td>
              <td> ${invoice?.discountPrice?.toFixed(2)}</td>
          </tr>
          <tr>
            <td>Total</td>
              <td> ${invoice?.totalPrice?.toFixed(2)}</td>
          </tr>
        </tbody>
      </table>
      <div class="invoice-summary">
        <p><strong>Total Amount Paid:</strong> ${invoice?.totalPrice?.toFixed(
          2,
        )}</p>
      </div>
       <div class="terms-conditions">
        <h3>Terms and Conditions</h3>
          <p>1. <strong>Project Completion</strong>: Payment is contingent upon the successful completion of the project milestones.</p>
           <p>2. <strong>Dispute Resolution</strong>: Any disputes shall be resolved through info@doubtq.com or  arbitration in Surat, India.</p>
    </div>
      <div class="footer">
        <div class="contact-icons">
       <a href="https://www.facebook.com" target="_blank"><img src=${Facebook} alt="Facebook"/></a>
        <a href="https://www.linkedin.com" target="_blank"><img src=${Linkedin} alt="LinkedIn"/></a>
        <a href="https://www.instagram.com" target="_blank"><img src=${Instagram} alt="Instagram"/></a>
        <a href="https://www.youtube.com" target="_blank"><img src=${YouTube} alt="YouTube"/></a>
        <a href="mailto:info@doubtq.com" target="_blank"><img src=${Email} alt="Email"/></a>
        </div>
        <div class="copyright">
          <p>&copy; 2024 Doubtq.com. All rights reserved. | Get in touch: info@doubtq.com</p>
        </div>
      </div>
    </div>
  </body>
  </html>
  `;

  const generatePdf = () => {
    const element = document.getElementById("invoice-content");

    if (!element) {
      return;
    }

    const doc = new jsPDF("p", "pt", "letter");

    doc.html(element, {
      callback: function (doc) {
        doc.save("invoice.pdf");
      },
      x: 20,
      y: 20,
      width: 572,
      windowWidth: 700,
    });
  };

  useEffect(() => {
    if (invoice) {
      generatePdf();
    }
  }, [invoice, yourInvoiceHTMLContent]);

  const handleInvoiceButtonClick = (order) => {
    setInvoice(order);
  };

  const orderFilterStatus = [
    { label: "Unpaid", value: "Unpaid" },
    { label: "Paid", value: "Paid" },
    { label: "Completed", value: "Completed" },
    { label: "Refunded", value: "Refund" },
  ];

  return (
    <div>
      <Helmet>
        <title>
          Order History | Get Personalized Academic Success with DoubtQ | Online
          Question Help
        </title>
        <meta
          name="description"
          content="Welcome to the Order History of DoubtQ"
        />
        <meta property="og:title" content="Order History - DoubtQ" />
        <meta
          property="og:description"
          content="Explore personalized academic help on DoubtQ's Order History"
        />
      </Helmet>
      <div className="dashboard dash-mobile">
        <Row>
          <Col md="6">
            <h1 className="text-start mb-5 md:mb-5">Order History</h1>
          </Col>
        </Row>
        <div
          className="ml-5"
          style={{
            marginLeft: "8px",
            marginRight: "8px",
            borderRadius: "10px",
            padding: "2px",
          }}
        >
          <Row className="mb-4 pagelayout-custom ">
            <Col md="4">
              <div className="search-box">
                <FiSearch className="search-icon2" />
                <input
                  type="text"
                  placeholder="Search Order ID..."
                  className="search-input"
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </Col>
            <Col md="8" className="text-end">
              <div className="payment-filter d-flex justify-content-start justify-content-md-end gap-1 md:gap-3 flex-wrap mt-2 md:mt-4">
                {orderFilterStatus.map((item, index) => {
                  return (
                    <span
                      key={index}
                      className={`payment-status ${item.value} ${
                        status === item.value ? "active-pay" : ""
                      }`}
                      onClick={() => setStatus(item.value)}
                    >
                      {item.label}
                    </span>
                  );
                })}
              </div>
            </Col>
          </Row>
        </div>



<Row>
  {loading ? (
    <Col className="text-center w-100 mt-4">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </Col>
  ) : !loading && pageData.length === 0 ? (
    <Col className="text-center w-100 mt-4">
      <h2>No data found.</h2>
    </Col>
  ) : (
    pageData.map((order, index) => (
      <Col
        key={order._id} // ✅ fixed key
        xs={12}
        sm={12}
        md={6}
        lg={6}
        className="mb-4"
      >
        <div
          className="order-card show pagelayout-custom"
          style={{
            transitionDelay: `${index * 0.1}s`,
          }}
        >
          <div className="order-card-top">
            <div
              style={{
                position: "relative",
                display: "inline-block",
              }}
            >
              <span className="label">Order ID</span>
              <h5>#{order.displayId}</h5>

              {getUnreadCount(order.displayId) > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: "-6px",
                    right: "-16px",
                    background: "#e53e3e",
                    color: "#fff",
                    borderRadius: "9999px",
                    fontSize: "0.7rem",
                    fontWeight: 700,
                    minWidth: "18px",
                    height: "18px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "0 4px",
                  }}
                >
                  {getUnreadCount(order.displayId) > 99
                    ? "99+"
                    : getUnreadCount(order.displayId)}
                </span>
              )}
            </div>

            <div className="text-end">
              <span className="label">Amount</span>
              <h3>${order?.totalPrice?.toFixed(2)}</h3>
            </div>
          </div>

          <div className="order-service">
            <span className="label">Service Type</span>
            <h6>
              {order?.subCategoryId?.name ||
                order?.courseId?.courseName}
            </h6>
          </div>

          <div className="order-card-bottom">
            <div>
              <span className="label">Order Date</span>
              <p>{dateFormat(order.updatedAt)}</p>
            </div>

            <div className="button-wrapper">
              {(order.studentPaymentStatus === "Completed" ||
                order.studentPaymentStatus === "Paid") && (
                <Button
                  varient="linear-gradient-primar"
                  className="invoice-btn"
                  text={"Invoice"}
                  onClick={() => handleInvoiceButtonClick(order)}
                />
              )}

              <Button
                onClick={() => handleViewButtonClick(order)}
                varient="outline-linear-gradient-primary"
                className="invoice-btn"
                text={"Chat"}
              />

              <Button
                onClick={() => handleViewButtonClick(order)}
                varient="linear-gradient-primary"
                className="invoice-btn"
                text={"View"}
              />
            </div>
          </div>
        </div>
      </Col>
    ))
  )}
</Row>

        <Row className="pt-3 float-end">
          <Col className="text-center">
            <Pagination className="mt-4">
              <PaginationItem disabled={currentPage === 1}>
                <PaginationLink
                  previous
                  onClick={() => handlePaginationClick(currentPage - 1)}
                />
              </PaginationItem>
              {Array.from({ length: totalPages || 0 }, (_, i) => (
                <PaginationItem key={i + 1} active={i + 1 === currentPage}>
                  <PaginationLink onClick={() => handlePaginationClick(i + 1)}>
                    {i + 1}
                  </PaginationLink>
                </PaginationItem>
              ))}
              <PaginationItem disabled={currentPage === (totalPages || 1)}>
                <PaginationLink
                  next
                  onClick={() => handlePaginationClick(currentPage + 1)}
                />
              </PaginationItem>
            </Pagination>
          </Col>
        </Row>
      </div>

      {invoice && (
        <div style={{ display: "none" }}>
          <div
            id="invoice-content"
            dangerouslySetInnerHTML={{ __html: yourInvoiceHTMLContent }}
          />
        </div>
      )}
    </div>
  );
};

export default DashboardOrderHistory;
